module.exports = __webpack_public_path__ + "img/ics_o_services_active.95f3d04e.svg";